import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import { getVehicle, serviceVehicle } from '../../redux/actions/vehicles';
import {
  IconButton,
  Card,
  Notification,
  RouteWrapper,
  ServiceVehicleForm,
  HeadingSection,
  Section,
  Loader,
} from '../../components';

interface Props {
  match: any;
  goBack: () => void;
  getVehicle: (id: number) => Promise<{ error: boolean; data: IVehicle }>;
  serviceVehicle: (id: number, data: IServiceFields) => Promise<any>;
}

interface State {
  id: number;
  isFetching: boolean;
  vehicle: IVehicle;
  error?: string | boolean;
}

class ServiceView extends React.Component<Props, State> {
  state = {
    id: this.props.match.params.id,
    isFetching: true,
    vehicle: null as IVehicle,
    error: false,
  };

  async componentDidMount() {
    const { error, data } = await this.props.getVehicle(this.state.id);
    this.setState({ vehicle: !error ? data : null, isFetching: false });
  }

  serviceVehicle = async (data) => {
    if (this.state.isFetching) {
      return;
    }
    this.setState({ isFetching: true, error: false });
    const { error } = await this.props.serviceVehicle(this.state.id, data);
    if (error) {
      this.setState({ error, isFetching: false });
    } else {
      this.props.goBack();
    }
  };

  render() {
    const title = this.state.vehicle
      ? (this.state.vehicle as any).vehicle_type_name
      : 'Vehicle';
    return (
      <RouteWrapper
        title="Service Vehicle"
        requirePermission="MANAGE_SERVICE"
        breadcrumbs={[
          { link: '/service', text: 'Servicing' },
          { link: `/service/${this.state.id}`, text: title },
        ]}
      >
        <HeadingSection
          title={title}
          controls={[
            <IconButton
              icon="undo"
              className="is-default is-pulled-right"
              handleClick={() => {
                this.props.goBack();
              }}
              key="return"
            >
              Return
            </IconButton>,
          ]}
        />
        <Section>
          <div className="columns is-centered">
            <div className="column is-12-desktop is-7-widescreen">
              <Card>
                {!this.state.isFetching ? (
                  <div>
                    <table className="field">
                      <tbody>
                        <tr>
                          <td>
                            <strong>Vehicle</strong>
                          </td>
                          <td>
                            {this.state.vehicle.registration}
                            <br />
                            <small>
                              {(this.state.vehicle as any).vehicle_type_name}
                            </small>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>Service Mileage</strong>
                          </td>
                          <td>{this.state.vehicle.service_mileage}</td>
                        </tr>
                      </tbody>
                    </table>
                    <ServiceVehicleForm
                      onSubmit={this.serviceVehicle}
                      vehicle={this.state.vehicle}
                    />
                  </div>
                ) : (
                  <Loader fullwidth />
                )}
                {this.state.error && (
                  <Notification type="danger">{this.state.error}</Notification>
                )}
              </Card>
            </div>
          </div>
        </Section>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({}) => ({});

const mapDispatchToProps = (dispatch) => ({
  goBack: () => dispatch(goBack()),
  getVehicle: (id: number) => dispatch(getVehicle(id)),
  serviceVehicle: (id: number, data: IServiceFields) =>
    dispatch(serviceVehicle(id, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ServiceView);
